import React, { useEffect, useState } from "react";
import { successfulAction } from "../../js/issues/IssueActionsCtrls";
import { getTripGroupUsers } from "../../js/trips/tripGroupService";
import { IssueService } from "../../js/issues/issueService";
import { Agent, IssueAssignProps } from "../../js/headersegment/interfaces";

const IssueAssign: React.FC<IssueAssignProps> = ({ ok, cancel, issue, issueUpdated, size, loadSpinner }) => {
    const [loadingView, setLoadingView] = useState(true);
    const [canSelectAssignee, setCanSelectAssignee] = useState(false);
    const [unableToSelectMessage, setUnableToSelectMessage] = useState(
        'Unable to get a list of agents at this time.'
    );
    const [assignToOptions, setAssignToOptions] = useState<{ name: string; value: string }[]>([]);
    const [assignTo, setAssignTo] = useState<string | null>(null);

    useEffect(() => {
        const fetchTripGroupUsers = async () => {
            try {
                loadSpinner(true);
                const resp = await getTripGroupUsers(issue?.tripGroupId);
                if (resp?.status === 200) {
                    if (resp?.data?.length) {
                        const options = resp.data.filter((assignLists: { userFullObj?: { active: boolean } }) => assignLists?.userFullObj?.active).map((agent: Agent) => ({
                            name: agent.id,
                            value: agent.user.aav1UserId,
                        }));
                        setAssignToOptions(options);
                        setAssignTo(options[0]?.value || null);
                        setCanSelectAssignee(true);
                    } else {
                        setUnableToSelectMessage('No agents are available to select from.');
                    }
                }
            } catch (error) {
                loadSpinner(false);
                setUnableToSelectMessage('Unable to get a list of agents at this time.');
            } finally {
                loadSpinner(false);
                setLoadingView(false);
            }
        };
        fetchTripGroupUsers();
    }, [issue.tripGroupId]);

    const handleOk = async (e: React.FormEvent) => {
        e.preventDefault();
        const response = await IssueService.assign(
            [
                {
                    id: issue.id,
                    tripId: issue.tripId,
                    recordLocator: issue.recordLocator,
                }
            ],
            assignTo
        );
        if (response && successfulAction(response)) {
            issueUpdated({
                tripId: issue.tripId as string,
                issueId: issue.id as string
            });
        }
        ok();
    };

    return (
        <div className={`issue-assign issue-resolution-modal modal-dialog modal-${size || 'md'}`}>
            <form name="form" noValidate onSubmit={handleOk}>
                <div className="title">
                    ASSIGN ISSUE TO
                    <a onClick={cancel}>
                        <i id="modalCancelled" className="cancel pull-right glyphicon icon-white glyphicon-remove"></i>
                    </a>
                </div>

                <div className="content">
                    <div className="choices">
                        {!loadingView ? (canSelectAssignee ? (
                            <div className="row">
                                <select
                                    size={10}
                                    className="form-control btn btn-default dropdown-toggle"
                                    value={assignTo || ''}
                                    onChange={(e) => setAssignTo(e.target.value)}
                                    required
                                >
                                    {assignToOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8 center">{unableToSelectMessage}</div>
                                <div className="col-md-2"></div>
                            </div>
                        )): (<></>)}
                    </div>

                    <div className="action">
                        <button id="modalSubmitted" className="btn btn-default button-action" disabled={!canSelectAssignee}>
                            ASSIGN
                        </button>
                        <input type="submit" style={{ position: 'absolute', left: '-9999px' }} />
                    </div>
                </div>
            </form>
        </div>
    );
}

export default IssueAssign;